import { render, staticRenderFns } from "./AppNoDataAvailable.vue?vue&type=template&id=2bb46894&"
import script from "./AppNoDataAvailable.vue?vue&type=script&lang=js&"
export * from "./AppNoDataAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports